{
	"title": "Instellingen",
	"description": "Verzendregels, prijsgroepen, locaties, medewerkers, tokens en bedrijfsgegevens.",
	"help": {
		"settings": {
			"title": "Instellingen",
			"area": "Instellingen",
			"short": "Wat voor de hele shop geldt: verzendregels, klantgroepen en de standaardstaffel van de shop, locaties van de voorraad, wie er in het beheer werkt, je persoonlijke tokens en de bedrijfsgegevens.",
			"terms": [
				"shippingRule:shippingRules",
				"price:customerGroup",
				"price:shopQuantityDiscount",
				"location:location",
				"employee:employees",
				"personalAccessToken:tokens",
				"companyDetails:companyDetails"
			]
		}
	}
}
